import PropTypes from 'prop-types'
import usePermission from 'utils/hooks/usePermission'

/**
 * Component to conditionally render children based on permission
 * @param {string} permission - Required permission
 * @param {ReactNode} children - Children to render if permission granted
 * @param {ReactNode} fallback - Optional fallback to render if permission denied
 */
const PermissionCheck = ({ permission, children, fallback = null }) => {
    const hasPermission = usePermission(permission)

    return hasPermission ? children : fallback
}

PermissionCheck.propTypes = {
    permission: PropTypes.string,
    children: PropTypes.node,
    fallback: PropTypes.node,
}

export default PermissionCheck
